var _path, _g, _path2, _path3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPickupSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 55,
    viewBox: "0 0 433 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.1075 24.248V29H77.7315V16.4H82.6635C83.3115 16.4 83.8755 16.508 84.3555 16.724C84.8355 16.928 85.2315 17.204 85.5435 17.552C85.8675 17.888 86.1075 18.278 86.2635 18.722C86.4315 19.154 86.5155 19.598 86.5155 20.054V20.486C86.5155 20.954 86.4315 21.416 86.2635 21.872C86.1075 22.316 85.8675 22.718 85.5435 23.078C85.2315 23.426 84.8355 23.708 84.3555 23.924C83.8755 24.14 83.3115 24.248 82.6635 24.248H80.1075ZM80.1075 21.98H82.4295C82.9575 21.98 83.3715 21.836 83.6715 21.548C83.9835 21.26 84.1395 20.888 84.1395 20.432V20.216C84.1395 19.76 83.9835 19.388 83.6715 19.1C83.3715 18.812 82.9575 18.668 82.4295 18.668H80.1075V21.98ZM89.023 26.84H92.047V22.232H89.239V20.072H94.315V26.84H96.907V29H89.023V26.84ZM94.873 17.426C94.873 17.666 94.825 17.894 94.729 18.11C94.645 18.314 94.525 18.494 94.369 18.65C94.213 18.794 94.027 18.914 93.811 19.01C93.607 19.094 93.391 19.136 93.163 19.136C92.923 19.136 92.701 19.094 92.497 19.01C92.293 18.914 92.113 18.794 91.957 18.65C91.801 18.494 91.675 18.314 91.579 18.11C91.495 17.894 91.453 17.666 91.453 17.426C91.453 17.186 91.495 16.964 91.579 16.76C91.675 16.544 91.801 16.364 91.957 16.22C92.113 16.064 92.293 15.944 92.497 15.86C92.701 15.764 92.923 15.716 93.163 15.716C93.391 15.716 93.607 15.764 93.811 15.86C94.027 15.944 94.213 16.064 94.369 16.22C94.525 16.364 94.645 16.544 94.729 16.76C94.825 16.964 94.873 17.186 94.873 17.426ZM108.595 25.724C108.391 26.78 107.905 27.632 107.137 28.28C106.381 28.928 105.367 29.252 104.095 29.252C103.435 29.252 102.817 29.15 102.241 28.946C101.677 28.742 101.185 28.448 100.765 28.064C100.345 27.68 100.015 27.206 99.7745 26.642C99.5345 26.078 99.4145 25.436 99.4145 24.716V24.5C99.4145 23.78 99.5345 23.132 99.7745 22.556C100.015 21.98 100.345 21.488 100.765 21.08C101.197 20.672 101.695 20.36 102.259 20.144C102.835 19.928 103.447 19.82 104.095 19.82C105.343 19.82 106.351 20.144 107.119 20.792C107.899 21.44 108.391 22.292 108.595 23.348L106.363 23.924C106.291 23.396 106.063 22.94 105.679 22.556C105.295 22.172 104.755 21.98 104.059 21.98C103.735 21.98 103.429 22.04 103.141 22.16C102.853 22.28 102.601 22.454 102.385 22.682C102.169 22.898 101.995 23.168 101.863 23.492C101.743 23.804 101.683 24.158 101.683 24.554V24.662C101.683 25.058 101.743 25.412 101.863 25.724C101.995 26.024 102.169 26.276 102.385 26.48C102.601 26.684 102.853 26.84 103.141 26.948C103.429 27.044 103.735 27.092 104.059 27.092C104.755 27.092 105.283 26.918 105.643 26.57C106.015 26.222 106.255 25.754 106.363 25.166L108.595 25.724ZM113.892 23.348H114.324L116.7 20.072H119.184V20.18L116.304 24.266V24.59L119.472 28.892V29H116.88L114.324 25.508H113.892V29H111.624V16.4H113.892V23.348ZM127.973 20.072H130.241V29H127.973V27.704H127.649C127.253 28.736 126.401 29.252 125.093 29.252C124.649 29.252 124.235 29.18 123.851 29.036C123.467 28.892 123.131 28.67 122.843 28.37C122.555 28.07 122.327 27.698 122.159 27.254C122.003 26.798 121.925 26.264 121.925 25.652V20.072H124.193V25.184C124.193 25.82 124.343 26.318 124.643 26.678C124.943 27.026 125.393 27.2 125.993 27.2C126.677 27.2 127.175 26.984 127.487 26.552C127.811 26.108 127.973 25.508 127.973 24.752V20.072ZM134.747 32.6H132.479V20.072H134.747V21.368H135.071C135.311 20.876 135.659 20.498 136.115 20.234C136.571 19.958 137.153 19.82 137.861 19.82C138.389 19.82 138.887 19.922 139.355 20.126C139.835 20.33 140.249 20.63 140.597 21.026C140.957 21.41 141.239 21.884 141.443 22.448C141.659 23.012 141.767 23.654 141.767 24.374V24.698C141.767 25.43 141.665 26.078 141.461 26.642C141.257 27.206 140.981 27.686 140.633 28.082C140.285 28.466 139.871 28.76 139.391 28.964C138.923 29.156 138.413 29.252 137.861 29.252C137.453 29.252 137.099 29.21 136.799 29.126C136.499 29.042 136.235 28.928 136.007 28.784C135.791 28.64 135.605 28.478 135.449 28.298C135.305 28.106 135.179 27.908 135.071 27.704H134.747V32.6ZM137.123 27.092C137.831 27.092 138.401 26.876 138.833 26.444C139.277 26 139.499 25.4 139.499 24.644V24.428C139.499 23.672 139.277 23.078 138.833 22.646C138.401 22.202 137.831 21.98 137.123 21.98C136.415 21.98 135.839 22.208 135.395 22.664C134.963 23.108 134.747 23.696 134.747 24.428V24.644C134.747 25.376 134.963 25.97 135.395 26.426C135.839 26.87 136.415 27.092 137.123 27.092Z",
    fill: "#409BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_173:31488)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1698 3H413.83L414.84 2.99999H415.849V2.10458H414.84H413.83V2H22.1698V2.10458H21.1604H20.1509V2.99999H21.1604L22.1698 3ZM22.1698 45.9797H411.811L412.821 45.9796H413.83V45.0842L414.84 45.0842H415.849V44.1888L416.858 44.1888H417.868V43.2934L418.877 43.2934H419.887V42.398H420.896H421.906V41.5026H420.896H419.887V42.398L418.877 42.398H417.868V43.2934H416.858H415.849V44.1888H414.84H413.83V45.0842H412.821H411.811V44.9797H22.1698V44.1888H21.1604H20.1509V43.2934H19.1415H18.1321V42.398H17.1226L16.1132 42.398V41.5026H15.1038H14.0943V42.398H15.1038H16.1132V43.2934H17.1226L18.1321 43.2934V44.1888H19.1415L20.1509 44.1888V45.0842H21.1604H22.1698V45.9797ZM421.906 40.6072H422.915H423.925V41.5026H422.915H421.906V40.6072ZM424.934 39.7118V40.6072L423.925 40.6072V39.7118H424.934ZM425.943 38.8164V39.7118H424.934V38.8164H425.943ZM426.953 37.921V38.8164L425.943 38.8164V37.921H426.953ZM426.953 37.921V37.0256H427.962V37.921L426.953 37.921ZM428.972 36.1301H427.962V37.0255H428.972V36.1301ZM429.981 35.2347V36.1301L428.972 36.1301V35.2347H429.981ZM430.991 34.3393H429.981V35.2347L430.991 35.2347V34.3393ZM430.991 34.3393H432V33.4439V13.7449V12.8495H430.991V13.7449V33.4439V34.3393ZM14.0943 40.6072H13.0849H12.0755V39.7118H11.066L11.066 38.8164H10.0566V37.921H9.04717L9.04717 37.0256H8.03774V37.921L9.04717 37.921V38.8164L10.0566 38.8164V39.7118H11.066V40.6072L12.0755 40.6072V41.5026H13.0849H14.0943V40.6072ZM7.0283 36.1301H8.03774V37.0255H7.0283V36.1301ZM7.0283 35.2347H6.01887L6.01887 34.3393H5.00943L5.00943 33.4439V13.7449V12.8495H4V13.7449V33.4439V34.3393H5.00943V35.2347L6.01887 35.2347V36.1301H7.0283V35.2347ZM415.849 3.89541H416.858H417.868V4.79081H418.877L419.887 4.79081V5.68622H420.896H421.906V4.79081H420.896H419.887V3.8954H418.877L417.868 3.89541V3H416.858H415.849V3.89541ZM421.906 6.58163H422.915H423.925V7.47704H424.934V6.58163L423.925 6.58163V5.68622H422.915H421.906V6.58163ZM425.943 8.37246H424.934V7.47705H425.943V8.37246ZM426.953 9.26786H425.943V8.37246L426.953 8.37245V9.26786ZM426.953 9.26786L427.962 9.26786V10.1633H426.953V9.26786ZM428.972 11.0587H427.962V10.1633H428.972V11.0587ZM429.981 11.9541H428.972V11.0587L429.981 11.0587V11.9541ZM429.981 11.9541L430.991 11.9541V12.8495H429.981V11.9541ZM20.1509 3.89541H19.1415H18.1321V3H19.1415H20.1509V3.89541ZM16.1132 4.79081V3.8954H17.1226L18.1321 3.89541V4.79081H17.1226L16.1132 4.79081ZM16.1132 4.79081V5.68622H15.1038H14.0943V4.79081H15.1038H16.1132ZM14.0943 6.58163H13.0849H12.0755V5.68622H13.0849H14.0943V6.58163ZM12.0755 6.58163V7.47704H11.066V6.58163L12.0755 6.58163ZM10.0566 8.37246H11.066V7.47705H10.0566V8.37246ZM9.04717 9.26786H10.0566V8.37246L9.04717 8.37245V9.26786ZM9.04717 9.26786L9.04717 10.1633H8.03774V9.26786L9.04717 9.26786ZM7.0283 11.0587H8.03774V10.1633H7.0283V11.0587ZM7.0283 11.9541H6.01887V11.0587H7.0283V11.9541ZM6.01887 11.9541L5.00943 11.9541V12.8495H6.01887L6.01887 11.9541Z",
    fill: "#409BFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M413.83 3V3.5V3ZM22.1698 3L22.1698 3.5H22.1698V3ZM414.84 2.99999V2.49999V2.99999ZM415.849 2.99999V3.49999H416.349V2.99999H415.849ZM415.849 2.10458H416.349V1.60458H415.849V2.10458ZM413.83 2.10458H413.33V2.60458H413.83V2.10458ZM413.83 2H414.33V1.5H413.83V2ZM22.1698 2V1.5H21.6698V2H22.1698ZM22.1698 2.10458V2.60458H22.6698V2.10458H22.1698ZM20.1509 2.10458V1.60458H19.6509V2.10458H20.1509ZM20.1509 2.99999H19.6509V3.49999H20.1509V2.99999ZM21.1604 2.99999L21.1604 2.49999H21.1604V2.99999ZM411.811 45.9797V46.4797V45.9797ZM22.1698 45.9797H21.6698V46.4797H22.1698V45.9797ZM412.821 45.9796V45.4796V45.9796ZM413.83 45.9796V46.4796H414.33V45.9796H413.83ZM414.84 45.0842V45.5842V45.0842ZM415.849 45.0842V45.5842H416.349V45.0842H415.849ZM416.858 44.1888V44.6888V44.1888ZM417.868 44.1888V44.6888H418.368V44.1888H417.868ZM418.877 43.2934V43.7934V43.2934ZM419.887 43.2934V43.7934H420.387V43.2934H419.887ZM421.906 42.398V42.898H422.406V42.398H421.906ZM421.906 41.5026H422.406V41.0026H421.906V41.5026ZM419.887 41.5026V41.0026H419.387V41.5026H419.887ZM418.877 42.398V41.898V42.398ZM417.868 42.398V41.898H417.368V42.398H417.868ZM415.849 43.2934V42.7934H415.349V43.2934H415.849ZM413.83 44.1888V43.6888H413.33V44.1888H413.83ZM411.811 45.0842H411.311V45.5842H411.811V45.0842ZM411.811 44.9797H412.311V44.4797H411.811V44.9797ZM22.1698 44.9797H21.6698V45.4797H22.1698V44.9797ZM22.1698 44.1888H22.6698V43.6888H22.1698V44.1888ZM20.1509 43.2934H20.6509V42.7934H20.1509V43.2934ZM18.1321 42.398H18.6321V41.898H18.1321V42.398ZM17.1226 42.398V41.898H17.1226L17.1226 42.398ZM16.1132 41.5026H16.6132V41.0026H16.1132V41.5026ZM14.0943 41.5026V41.0026H13.5943V41.5026H14.0943ZM14.0943 42.398H13.5943V42.898H14.0943V42.398ZM16.1132 43.2934H15.6132V43.7934H16.1132V43.2934ZM17.1226 43.2934V43.7934H17.1226L17.1226 43.2934ZM18.1321 44.1888H17.6321V44.6888H18.1321V44.1888ZM19.1415 44.1888V44.6888H19.1415L19.1415 44.1888ZM20.1509 45.0842H19.6509V45.5842H20.1509V45.0842ZM22.1698 45.0842H22.6698V44.5842H22.1698V45.0842ZM421.906 40.6072V40.1072H421.406V40.6072H421.906ZM423.925 41.5026V42.0026H424.425V41.5026H423.925ZM421.906 41.5026H421.406V42.0026H421.906V41.5026ZM424.934 40.6072V41.1072H425.434V40.6072H424.934ZM423.925 39.7118V39.2118H423.425V39.7118H423.925ZM425.943 39.7118V40.2118H426.443V39.7118H425.943ZM424.934 38.8164V38.3164H424.434V38.8164H424.934ZM426.953 38.8164V39.3164H427.453V38.8164H426.953ZM425.943 37.921V37.421H425.443V37.921H425.943ZM426.953 37.0256V36.5256H426.453V37.0256H426.953ZM427.962 37.0256H428.462V36.5256H427.962V37.0256ZM427.962 37.921V38.421H428.462V37.921H427.962ZM427.962 36.1301V35.6301H427.462V36.1301H427.962ZM427.962 37.0255H427.462V37.5255H427.962V37.0255ZM428.972 37.0255V37.5255H429.472V37.0255H428.972ZM429.981 36.1301V36.6301H430.481V36.1301H429.981ZM428.972 35.2347V34.7347H428.472V35.2347H428.972ZM429.981 34.3393V33.8393H429.481V34.3393H429.981ZM430.991 35.2347V35.7347H431.491V35.2347H430.991ZM432 34.3393V34.8393H432.5V34.3393H432ZM432 12.8495H432.5V12.3495H432V12.8495ZM430.991 12.8495V12.3495H430.491V12.8495H430.991ZM14.0943 40.6072H14.5943V40.1072H14.0943V40.6072ZM12.0755 39.7118H12.5755V39.2118H12.0755V39.7118ZM11.066 38.8164H11.566L11.566 38.3164H11.066V38.8164ZM10.0566 37.921H10.5566V37.421H10.0566V37.921ZM9.04717 37.0256H9.54717L9.54717 36.5256H9.04717V37.0256ZM8.03774 37.0256V36.5256H7.53774V37.0256H8.03774ZM8.03774 37.921H7.53774V38.421H8.03774L8.03774 37.921ZM9.04717 38.8164H8.54717V39.3164H9.04717L9.04717 38.8164ZM10.0566 39.7118H9.5566V40.2118H10.0566V39.7118ZM11.066 40.6072H10.566V41.1072H11.066L11.066 40.6072ZM12.0755 41.5026H11.5755V42.0026H12.0755V41.5026ZM14.0943 41.5026V42.0026H14.5943V41.5026H14.0943ZM8.03774 36.1301H8.53774V35.6301H8.03774V36.1301ZM7.0283 36.1301V35.6301H6.5283V36.1301H7.0283ZM8.03774 37.0255V37.5255H8.53774V37.0255H8.03774ZM7.0283 37.0255H6.5283V37.5255H7.0283V37.0255ZM7.0283 35.2347H7.5283V34.7347H7.0283V35.2347ZM6.01887 34.3393H6.51887L6.51887 33.8393H6.01887V34.3393ZM5.00943 33.4439H5.50943H5.00943ZM5.00943 12.8495H5.50943V12.3495H5.00943V12.8495ZM4 12.8495V12.3495H3.5V12.8495H4ZM4 34.3393H3.5V34.8393H4V34.3393ZM5.00943 35.2347H4.50943V35.7347H5.00944L5.00943 35.2347ZM6.01887 36.1301H5.51887V36.6301H6.01887V36.1301ZM7.0283 36.1301V36.6301H7.5283V36.1301H7.0283ZM415.849 3.89541H415.349V4.39541H415.849V3.89541ZM417.868 4.79081H417.368V5.29081H417.868V4.79081ZM418.877 4.79081V5.29081V4.79081ZM419.887 5.68622H419.387V6.18622H419.887V5.68622ZM421.906 5.68622V6.18622H422.406V5.68622H421.906ZM421.906 4.79081H422.406V4.29081H421.906V4.79081ZM419.887 3.8954H420.387V3.3954H419.887V3.8954ZM418.877 3.8954V3.3954V3.8954ZM417.868 3H418.368V2.5H417.868V3ZM415.849 3V2.5H415.349V3H415.849ZM421.906 6.58163H421.406V7.08163H421.906V6.58163ZM423.925 7.47704H423.425V7.97704H423.925V7.47704ZM424.934 7.47704V7.97704H425.434V7.47704H424.934ZM424.934 6.58163H425.434V6.08163L424.934 6.08163V6.58163ZM423.925 5.68622H424.425V5.18622H423.925V5.68622ZM421.906 5.68622V5.18622H421.406V5.68622H421.906ZM424.934 8.37246H424.434V8.87246H424.934V8.37246ZM424.934 7.47705V6.97705H424.434V7.47705H424.934ZM425.943 7.47705H426.443V6.97705H425.943V7.47705ZM425.943 9.26786H425.443V9.76786H425.943V9.26786ZM426.953 8.37245H427.453V7.87245L426.953 7.87245V8.37245ZM427.962 9.26786H428.462V8.76786L427.962 8.76786V9.26786ZM427.962 10.1633V10.6633H428.462V10.1633H427.962ZM426.953 10.1633H426.453V10.6633H426.953V10.1633ZM427.962 11.0587H427.462V11.5587H427.962V11.0587ZM427.962 10.1633V9.66327H427.462V10.1633H427.962ZM428.972 10.1633H429.472V9.66327H428.972V10.1633ZM428.972 11.9541H428.472V12.4541H428.972V11.9541ZM429.981 11.0587H430.481V10.5587L429.981 10.5587V11.0587ZM430.991 11.9541H431.491V11.4541L430.991 11.4541V11.9541ZM430.991 12.8495V13.3495H431.491V12.8495H430.991ZM429.981 12.8495H429.481V13.3495H429.981V12.8495ZM20.1509 3.89541V4.39541H20.6509V3.89541H20.1509ZM18.1321 3V2.5H17.6321V3H18.1321ZM20.1509 3H20.6509V2.5H20.1509V3ZM16.1132 3.8954V3.3954H15.6132V3.8954H16.1132ZM17.1226 3.8954L17.1226 3.3954H17.1226V3.8954ZM18.1321 4.79081V5.29081H18.6321V4.79081H18.1321ZM17.1226 4.79081L17.1226 5.29081H17.1226V4.79081ZM16.1132 5.68622V6.18622H16.6132V5.68622H16.1132ZM14.0943 5.68622H13.5943V6.18622H14.0943V5.68622ZM14.0943 4.79081V4.29081H13.5943V4.79081H14.0943ZM14.0943 6.58163V7.08163H14.5943V6.58163H14.0943ZM12.0755 5.68622V5.18622H11.5755V5.68622H12.0755ZM14.0943 5.68622H14.5943V5.18622H14.0943V5.68622ZM12.0755 7.47704V7.97704H12.5755V7.47704H12.0755ZM11.066 7.47704H10.566V7.97704H11.066V7.47704ZM11.066 6.58163L11.066 6.08163L10.566 6.08163V6.58163H11.066ZM11.066 8.37246V8.87246H11.566V8.37246H11.066ZM11.066 7.47705H11.566V6.97705H11.066V7.47705ZM10.0566 7.47705V6.97705H9.5566V7.47705H10.0566ZM10.0566 9.26786V9.76786H10.5566V9.26786H10.0566ZM9.04717 8.37245L9.04717 7.87245L8.54717 7.87245V8.37245H9.04717ZM9.04717 10.1633V10.6633H9.54717L9.54717 10.1633H9.04717ZM8.03774 10.1633H7.53774V10.6633H8.03774V10.1633ZM8.03774 9.26786L8.03774 8.76786L7.53774 8.76786V9.26786H8.03774ZM8.03774 11.0587V11.5587H8.53774V11.0587H8.03774ZM7.0283 11.0587H6.5283V11.5587H7.0283V11.0587ZM8.03774 10.1633H8.53774V9.66327H8.03774V10.1633ZM7.0283 10.1633V9.66327H6.5283V10.1633H7.0283ZM7.0283 11.9541V12.4541H7.5283V11.9541H7.0283ZM6.01887 11.0587V10.5587H5.51887V11.0587H6.01887ZM7.0283 11.0587H7.5283V10.5587H7.0283V11.0587ZM5.00943 11.9541L5.00944 11.4541L4.50943 11.4541V11.9541H5.00943ZM5.00943 12.8495H4.50943V13.3495H5.00943V12.8495ZM6.01887 12.8495V13.3495H6.51887L6.51887 12.8495H6.01887ZM413.83 2.5H22.1698V3.5H413.83V2.5ZM414.84 2.49999L413.83 2.5V3.5L414.84 3.49999V2.49999ZM415.849 2.49999H414.84V3.49999H415.849V2.49999ZM415.349 2.10458V2.99999H416.349V2.10458H415.349ZM414.84 2.60458H415.849V1.60458H414.84V2.60458ZM413.83 2.60458H414.84V1.60458H413.83V2.60458ZM413.33 2V2.10458H414.33V2H413.33ZM22.1698 2.5H413.83V1.5H22.1698V2.5ZM22.6698 2.10458V2H21.6698V2.10458H22.6698ZM21.1604 2.60458H22.1698V1.60458H21.1604V2.60458ZM20.1509 2.60458H21.1604V1.60458H20.1509V2.60458ZM20.6509 2.99999V2.10458H19.6509V2.99999H20.6509ZM21.1604 2.49999H20.1509V3.49999H21.1604V2.49999ZM22.1698 2.5L21.1604 2.49999L21.1604 3.49999L22.1698 3.5L22.1698 2.5ZM411.811 45.4797H22.1698V46.4797H411.811V45.4797ZM412.821 45.4796L411.811 45.4797V46.4797L412.821 46.4796V45.4796ZM413.83 45.4796H412.821V46.4796H413.83V45.4796ZM413.33 45.0842V45.9796H414.33V45.0842H413.33ZM414.84 44.5842L413.83 44.5842V45.5842L414.84 45.5842V44.5842ZM415.849 44.5842H414.84V45.5842H415.849V44.5842ZM415.349 44.1888V45.0842H416.349V44.1888H415.349ZM416.858 43.6888L415.849 43.6888V44.6888L416.858 44.6888V43.6888ZM417.868 43.6888H416.858V44.6888H417.868V43.6888ZM417.368 43.2934V44.1888H418.368V43.2934H417.368ZM418.877 42.7934L417.868 42.7934V43.7934L418.877 43.7934V42.7934ZM419.887 42.7934H418.877V43.7934H419.887V42.7934ZM419.387 42.398V43.2934H420.387V42.398H419.387ZM420.896 41.898H419.887V42.898H420.896V41.898ZM421.906 41.898H420.896V42.898H421.906V41.898ZM421.406 41.5026V42.398H422.406V41.5026H421.406ZM420.896 42.0026H421.906V41.0026H420.896V42.0026ZM419.887 42.0026H420.896V41.0026H419.887V42.0026ZM420.387 42.398V41.5026H419.387V42.398H420.387ZM418.877 42.898L419.887 42.898V41.898L418.877 41.898V42.898ZM417.868 42.898H418.877V41.898H417.868V42.898ZM418.368 43.2934V42.398H417.368V43.2934H418.368ZM416.858 43.7934H417.868V42.7934H416.858V43.7934ZM415.849 43.7934H416.858V42.7934H415.849V43.7934ZM416.349 44.1888V43.2934H415.349V44.1888H416.349ZM414.84 44.6888H415.849V43.6888H414.84V44.6888ZM413.83 44.6888H414.84V43.6888H413.83V44.6888ZM414.33 45.0842V44.1888H413.33V45.0842H414.33ZM412.821 45.5842H413.83V44.5842H412.821V45.5842ZM411.811 45.5842H412.821V44.5842H411.811V45.5842ZM411.311 44.9797V45.0842H412.311V44.9797H411.311ZM22.1698 45.4797H411.811V44.4797H22.1698V45.4797ZM21.6698 44.1888V44.9797H22.6698V44.1888H21.6698ZM21.1604 44.6888H22.1698V43.6888H21.1604V44.6888ZM20.1509 44.6888H21.1604V43.6888H20.1509V44.6888ZM19.6509 43.2934V44.1888H20.6509V43.2934H19.6509ZM19.1415 43.7934H20.1509V42.7934H19.1415V43.7934ZM18.1321 43.7934H19.1415V42.7934H18.1321V43.7934ZM17.6321 42.398V43.2934H18.6321V42.398H17.6321ZM17.1226 42.898H18.1321V41.898H17.1226V42.898ZM16.1132 42.898L17.1226 42.898L17.1226 41.898L16.1132 41.898L16.1132 42.898ZM15.6132 41.5026V42.398H16.6132V41.5026H15.6132ZM15.1038 42.0026H16.1132V41.0026H15.1038V42.0026ZM14.0943 42.0026H15.1038V41.0026H14.0943V42.0026ZM14.5943 42.398V41.5026H13.5943V42.398H14.5943ZM15.1038 41.898H14.0943V42.898H15.1038V41.898ZM16.1132 41.898H15.1038V42.898H16.1132V41.898ZM16.6132 43.2934V42.398H15.6132V43.2934H16.6132ZM17.1226 42.7934H16.1132V43.7934H17.1226V42.7934ZM18.1321 42.7934L17.1226 42.7934L17.1226 43.7934L18.1321 43.7934L18.1321 42.7934ZM18.6321 44.1888V43.2934H17.6321V44.1888H18.6321ZM19.1415 43.6888H18.1321V44.6888H19.1415V43.6888ZM20.1509 43.6888L19.1415 43.6888L19.1415 44.6888L20.1509 44.6888L20.1509 43.6888ZM20.6509 45.0842V44.1888H19.6509V45.0842H20.6509ZM21.1604 44.5842H20.1509V45.5842H21.1604V44.5842ZM22.1698 44.5842H21.1604V45.5842H22.1698V44.5842ZM22.6698 45.9797V45.0842H21.6698V45.9797H22.6698ZM422.915 40.1072H421.906V41.1072H422.915V40.1072ZM423.925 40.1072H422.915V41.1072H423.925V40.1072ZM424.425 41.5026V40.6072H423.425V41.5026H424.425ZM422.915 42.0026H423.925V41.0026H422.915V42.0026ZM421.906 42.0026H422.915V41.0026H421.906V42.0026ZM421.406 40.6072V41.5026H422.406V40.6072H421.406ZM425.434 40.6072V39.7118H424.434V40.6072H425.434ZM423.925 41.1072L424.934 41.1072V40.1072L423.925 40.1072V41.1072ZM423.425 39.7118V40.6072H424.425V39.7118H423.425ZM424.934 39.2118H423.925V40.2118H424.934V39.2118ZM426.443 39.7118V38.8164H425.443V39.7118H426.443ZM424.934 40.2118H425.943V39.2118H424.934V40.2118ZM424.434 38.8164V39.7118H425.434V38.8164H424.434ZM425.943 38.3164H424.934V39.3164H425.943V38.3164ZM427.453 38.8164V37.921H426.453V38.8164H427.453ZM425.943 39.3164L426.953 39.3164V38.3164L425.943 38.3164V39.3164ZM425.443 37.921V38.8164H426.443V37.921H425.443ZM426.953 37.421H425.943V38.421H426.953V37.421ZM426.453 37.0256V37.921H427.453V37.0256H426.453ZM427.962 36.5256H426.953V37.5256H427.962V36.5256ZM428.462 37.921V37.0256H427.462V37.921H428.462ZM426.953 38.421L427.962 38.421V37.421L426.953 37.421V38.421ZM427.962 36.6301H428.972V35.6301H427.962V36.6301ZM428.462 37.0255V36.1301H427.462V37.0255H428.462ZM428.972 36.5255H427.962V37.5255H428.972V36.5255ZM428.472 36.1301V37.0255H429.472V36.1301H428.472ZM430.481 36.1301V35.2347H429.481V36.1301H430.481ZM428.972 36.6301L429.981 36.6301V35.6301L428.972 35.6301V36.6301ZM428.472 35.2347V36.1301H429.472V35.2347H428.472ZM429.981 34.7347H428.972V35.7347H429.981V34.7347ZM429.981 34.8393H430.991V33.8393H429.981V34.8393ZM430.481 35.2347V34.3393H429.481V35.2347H430.481ZM430.991 34.7347L429.981 34.7347V35.7347L430.991 35.7347V34.7347ZM430.491 34.3393V35.2347H431.491V34.3393H430.491ZM430.991 34.8393H432V33.8393H430.991V34.8393ZM432.5 34.3393V33.4439H431.5V34.3393H432.5ZM432.5 33.4439V13.7449H431.5V33.4439H432.5ZM432.5 13.7449V12.8495H431.5V13.7449H432.5ZM432 12.3495H430.991V13.3495H432V12.3495ZM430.491 12.8495V13.7449H431.491V12.8495H430.491ZM430.491 13.7449V33.4439H431.491V13.7449H430.491ZM430.491 33.4439V34.3393H431.491V33.4439H430.491ZM13.0849 41.1072H14.0943V40.1072H13.0849V41.1072ZM12.0755 41.1072H13.0849V40.1072H12.0755V41.1072ZM11.5755 39.7118V40.6072H12.5755V39.7118H11.5755ZM11.066 40.2118H12.0755V39.2118H11.066V40.2118ZM10.566 38.8164L10.566 39.7118H11.566L11.566 38.8164H10.566ZM10.0566 39.3164H11.066V38.3164H10.0566V39.3164ZM9.5566 37.921V38.8164H10.5566V37.921H9.5566ZM9.04717 38.421H10.0566V37.421H9.04717V38.421ZM8.54717 37.0256L8.54717 37.921H9.54717L9.54717 37.0256H8.54717ZM8.03774 37.5256H9.04717V36.5256H8.03774V37.5256ZM8.53774 37.921V37.0256H7.53774V37.921H8.53774ZM9.04717 37.421L8.03773 37.421L8.03774 38.421L9.04717 38.421L9.04717 37.421ZM9.54717 38.8164V37.921H8.54717V38.8164H9.54717ZM10.0566 38.3164L9.04717 38.3164L9.04717 39.3164L10.0566 39.3164L10.0566 38.3164ZM10.5566 39.7118V38.8164H9.5566V39.7118H10.5566ZM11.066 39.2118H10.0566V40.2118H11.066V39.2118ZM11.566 40.6072V39.7118H10.566V40.6072H11.566ZM12.0755 40.1072L11.066 40.1072L11.066 41.1072L12.0755 41.1072L12.0755 40.1072ZM12.5755 41.5026V40.6072H11.5755V41.5026H12.5755ZM13.0849 41.0026H12.0755V42.0026H13.0849V41.0026ZM14.0943 41.0026H13.0849V42.0026H14.0943V41.0026ZM13.5943 40.6072V41.5026H14.5943V40.6072H13.5943ZM8.03774 35.6301H7.0283V36.6301H8.03774V35.6301ZM8.53774 37.0255V36.1301H7.53774V37.0255H8.53774ZM7.0283 37.5255H8.03774V36.5255H7.0283V37.5255ZM6.5283 36.1301V37.0255H7.5283V36.1301H6.5283ZM6.01887 35.7347H7.0283V34.7347H6.01887V35.7347ZM5.51887 34.3393L5.51887 35.2347H6.51887L6.51887 34.3393H5.51887ZM5.00943 34.8393H6.01887V33.8393H5.00943V34.8393ZM4.50943 33.4439L4.50943 34.3393H5.50943L5.50943 33.4439H4.50943ZM5.50943 33.4439V13.7449H4.50943V33.4439H5.50943ZM5.50943 13.7449V12.8495H4.50943V13.7449H5.50943ZM5.00943 12.3495H4V13.3495H5.00943V12.3495ZM3.5 12.8495V13.7449H4.5V12.8495H3.5ZM3.5 13.7449V33.4439H4.5V13.7449H3.5ZM4.5 34.3393V33.4439H3.5V34.3393H4.5ZM5.00943 33.8393H4V34.8393H5.00943V33.8393ZM5.50943 35.2347V34.3393H4.50943V35.2347H5.50943ZM6.01887 34.7347L5.00943 34.7347L5.00944 35.7347L6.01887 35.7347L6.01887 34.7347ZM6.51887 36.1301V35.2347H5.51887V36.1301H6.51887ZM7.0283 35.6301H6.01887V36.6301H7.0283V35.6301ZM6.5283 35.2347V36.1301H7.5283V35.2347H6.5283ZM416.858 3.39541H415.849V4.39541H416.858V3.39541ZM417.868 3.39541H416.858V4.39541H417.868V3.39541ZM418.368 4.79081V3.89541H417.368V4.79081H418.368ZM418.877 4.29081H417.868V5.29081H418.877V4.29081ZM419.887 4.29081L418.877 4.29081V5.29081L419.887 5.29081V4.29081ZM420.387 5.68622V4.79081H419.387V5.68622H420.387ZM420.896 5.18622H419.887V6.18622H420.896V5.18622ZM421.906 5.18622H420.896V6.18622H421.906V5.18622ZM421.406 4.79081V5.68622H422.406V4.79081H421.406ZM420.896 5.29081H421.906V4.29081H420.896V5.29081ZM419.887 5.29081H420.896V4.29081H419.887V5.29081ZM419.387 3.8954V4.79081H420.387V3.8954H419.387ZM418.877 4.3954H419.887V3.3954H418.877V4.3954ZM417.868 4.39541L418.877 4.3954V3.3954L417.868 3.39541V4.39541ZM417.368 3V3.89541H418.368V3H417.368ZM416.858 3.5H417.868V2.5H416.858V3.5ZM415.849 3.5H416.858V2.5H415.849V3.5ZM416.349 3.89541V3H415.349V3.89541H416.349ZM422.915 6.08163H421.906V7.08163H422.915V6.08163ZM423.925 6.08163H422.915V7.08163H423.925V6.08163ZM424.425 7.47704V6.58163H423.425V7.47704H424.425ZM424.934 6.97704H423.925V7.97704H424.934V6.97704ZM424.434 6.58163V7.47704H425.434V6.58163H424.434ZM423.925 7.08163L424.934 7.08163V6.08163L423.925 6.08163V7.08163ZM423.425 5.68622V6.58163H424.425V5.68622H423.425ZM422.915 6.18622H423.925V5.18622H422.915V6.18622ZM421.906 6.18622H422.915V5.18622H421.906V6.18622ZM422.406 6.58163V5.68622H421.406V6.58163H422.406ZM424.934 8.87246H425.943V7.87246H424.934V8.87246ZM424.434 7.47705V8.37246H425.434V7.47705H424.434ZM425.943 6.97705H424.934V7.97705H425.943V6.97705ZM426.443 8.37246V7.47705H425.443V8.37246H426.443ZM425.943 9.76786H426.953V8.76786H425.943V9.76786ZM425.443 8.37246V9.26786H426.443V8.37246H425.443ZM426.953 7.87245L425.943 7.87246V8.87246L426.953 8.87245V7.87245ZM427.453 9.26786V8.37245H426.453V9.26786H427.453ZM427.962 8.76786L426.953 8.76786V9.76786L427.962 9.76786V8.76786ZM428.462 10.1633V9.26786H427.462V10.1633H428.462ZM426.953 10.6633H427.962V9.66327H426.953V10.6633ZM426.453 9.26786V10.1633H427.453V9.26786H426.453ZM427.962 11.5587H428.972V10.5587H427.962V11.5587ZM427.462 10.1633V11.0587H428.462V10.1633H427.462ZM428.972 9.66327H427.962V10.6633H428.972V9.66327ZM429.472 11.0587V10.1633H428.472V11.0587H429.472ZM428.972 12.4541H429.981V11.4541H428.972V12.4541ZM428.472 11.0587V11.9541H429.472V11.0587H428.472ZM429.981 10.5587L428.972 10.5587V11.5587L429.981 11.5587V10.5587ZM430.481 11.9541V11.0587H429.481V11.9541H430.481ZM430.991 11.4541L429.981 11.4541V12.4541L430.991 12.4541V11.4541ZM431.491 12.8495V11.9541H430.491V12.8495H431.491ZM429.981 13.3495H430.991V12.3495H429.981V13.3495ZM429.481 11.9541V12.8495H430.481V11.9541H429.481ZM19.1415 4.39541H20.1509V3.39541H19.1415V4.39541ZM18.1321 4.39541H19.1415V3.39541H18.1321V4.39541ZM17.6321 3V3.89541H18.6321V3H17.6321ZM19.1415 2.5H18.1321V3.5H19.1415V2.5ZM20.1509 2.5H19.1415V3.5H20.1509V2.5ZM20.6509 3.89541V3H19.6509V3.89541H20.6509ZM15.6132 3.8954V4.79081H16.6132V3.8954H15.6132ZM17.1226 3.3954H16.1132V4.3954H17.1226V3.3954ZM18.1321 3.39541L17.1226 3.3954L17.1226 4.3954L18.1321 4.39541L18.1321 3.39541ZM18.6321 4.79081V3.89541H17.6321V4.79081H18.6321ZM17.1226 5.29081H18.1321V4.29081H17.1226V5.29081ZM16.1132 5.29081L17.1226 5.29081L17.1226 4.29081L16.1132 4.29081L16.1132 5.29081ZM16.6132 5.68622V4.79081H15.6132V5.68622H16.6132ZM15.1038 6.18622H16.1132V5.18622H15.1038V6.18622ZM14.0943 6.18622H15.1038V5.18622H14.0943V6.18622ZM13.5943 4.79081V5.68622H14.5943V4.79081H13.5943ZM15.1038 4.29081H14.0943V5.29081H15.1038V4.29081ZM16.1132 4.29081H15.1038V5.29081H16.1132V4.29081ZM13.0849 7.08163H14.0943V6.08163H13.0849V7.08163ZM12.0755 7.08163H13.0849V6.08163H12.0755V7.08163ZM11.5755 5.68622V6.58163H12.5755V5.68622H11.5755ZM13.0849 5.18622H12.0755V6.18622H13.0849V5.18622ZM14.0943 5.18622H13.0849V6.18622H14.0943V5.18622ZM14.5943 6.58163V5.68622H13.5943V6.58163H14.5943ZM12.5755 7.47704V6.58163H11.5755V7.47704H12.5755ZM11.066 7.97704H12.0755V6.97704H11.066V7.97704ZM10.566 6.58163V7.47704H11.566V6.58163H10.566ZM12.0755 6.08163L11.066 6.08163L11.066 7.08163L12.0755 7.08163L12.0755 6.08163ZM11.066 7.87246H10.0566V8.87246H11.066V7.87246ZM10.566 7.47705V8.37246H11.566V7.47705H10.566ZM10.0566 7.97705H11.066V6.97705H10.0566V7.97705ZM10.5566 8.37246V7.47705H9.5566V8.37246H10.5566ZM10.0566 8.76786H9.04717V9.76786H10.0566V8.76786ZM9.5566 8.37246V9.26786H10.5566V8.37246H9.5566ZM9.04717 8.87245L10.0566 8.87246L10.0566 7.87246L9.04717 7.87245L9.04717 8.87245ZM9.54717 9.26786V8.37245H8.54717V9.26786H9.54717ZM9.54717 10.1633L9.54717 9.26786L8.54717 9.26786L8.54717 10.1633H9.54717ZM8.03774 10.6633H9.04717V9.66327H8.03774V10.6633ZM7.53774 9.26786V10.1633H8.53774V9.26786H7.53774ZM9.04717 8.76786L8.03774 8.76786L8.03773 9.76786L9.04717 9.76786L9.04717 8.76786ZM8.03774 10.5587H7.0283V11.5587H8.03774V10.5587ZM7.53774 10.1633V11.0587H8.53774V10.1633H7.53774ZM7.0283 10.6633H8.03774V9.66327H7.0283V10.6633ZM7.5283 11.0587V10.1633H6.5283V11.0587H7.5283ZM6.01887 12.4541H7.0283V11.4541H6.01887V12.4541ZM5.51887 11.0587V11.9541H6.51887V11.0587H5.51887ZM7.0283 10.5587H6.01887V11.5587H7.0283V10.5587ZM7.5283 11.9541V11.0587H6.5283V11.9541H7.5283ZM5.00943 12.4541L6.01887 12.4541L6.01887 11.4541L5.00944 11.4541L5.00943 12.4541ZM5.50943 12.8495V11.9541H4.50943V12.8495H5.50943ZM6.01887 12.3495H5.00943V13.3495H6.01887V12.3495ZM5.51887 11.9541L5.51887 12.8495H6.51887L6.51887 11.9541H5.51887Z",
    fill: "#409BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M282.808 16.4H287.38C288.94 16.4 290.098 16.766 290.854 17.498C291.61 18.218 291.988 19.34 291.988 20.864V24.536C291.988 26.06 291.61 27.188 290.854 27.92C290.098 28.64 288.94 29 287.38 29H282.808V26.714H283.996V18.668H282.808V16.4ZM287.38 26.732C288.208 26.732 288.784 26.54 289.108 26.156C289.444 25.76 289.612 25.148 289.612 24.32V20.864C289.612 20.144 289.444 19.598 289.108 19.226C288.784 18.854 288.208 18.668 287.38 18.668H286.372V26.732H287.38ZM296.404 25.274C296.416 25.538 296.476 25.784 296.584 26.012C296.704 26.228 296.86 26.42 297.052 26.588C297.256 26.744 297.484 26.87 297.736 26.966C298 27.05 298.276 27.092 298.564 27.092C299.128 27.092 299.56 26.996 299.86 26.804C300.16 26.6 300.376 26.36 300.508 26.084L302.452 27.164C302.344 27.392 302.194 27.632 302.002 27.884C301.81 28.124 301.558 28.346 301.246 28.55C300.946 28.754 300.574 28.922 300.13 29.054C299.698 29.186 299.188 29.252 298.6 29.252C297.928 29.252 297.316 29.144 296.764 28.928C296.212 28.712 295.732 28.4 295.324 27.992C294.928 27.584 294.616 27.086 294.388 26.498C294.172 25.91 294.064 25.244 294.064 24.5V24.392C294.064 23.708 294.178 23.084 294.406 22.52C294.646 21.956 294.97 21.476 295.378 21.08C295.786 20.684 296.26 20.378 296.8 20.162C297.352 19.934 297.94 19.82 298.564 19.82C299.332 19.82 299.992 19.958 300.544 20.234C301.096 20.498 301.552 20.84 301.912 21.26C302.272 21.668 302.536 22.124 302.704 22.628C302.872 23.12 302.956 23.6 302.956 24.068V25.274H296.404ZM298.546 21.872C297.97 21.872 297.502 22.022 297.142 22.322C296.782 22.61 296.548 22.946 296.44 23.33H300.652C300.58 22.91 300.352 22.562 299.968 22.286C299.596 22.01 299.122 21.872 298.546 21.872ZM305.373 26.84H308.505V18.56H305.481V16.4H310.773V26.84H313.689V29H305.373V26.84ZM316.611 26.84H319.635V22.232H316.827V20.072H321.903V26.84H324.495V29H316.611V26.84ZM322.461 17.426C322.461 17.666 322.413 17.894 322.317 18.11C322.233 18.314 322.113 18.494 321.957 18.65C321.801 18.794 321.615 18.914 321.399 19.01C321.195 19.094 320.979 19.136 320.751 19.136C320.511 19.136 320.289 19.094 320.085 19.01C319.881 18.914 319.701 18.794 319.545 18.65C319.389 18.494 319.263 18.314 319.167 18.11C319.083 17.894 319.041 17.666 319.041 17.426C319.041 17.186 319.083 16.964 319.167 16.76C319.263 16.544 319.389 16.364 319.545 16.22C319.701 16.064 319.881 15.944 320.085 15.86C320.289 15.764 320.511 15.716 320.751 15.716C320.979 15.716 321.195 15.764 321.399 15.86C321.615 15.944 321.801 16.064 321.957 16.22C322.113 16.364 322.233 16.544 322.317 16.76C322.413 16.964 322.461 17.186 322.461 17.426ZM326.84 20.072H329.288L331.394 27.92H331.718L333.824 20.072H336.272L333.716 29H329.396L326.84 20.072ZM340.49 25.274C340.502 25.538 340.562 25.784 340.67 26.012C340.79 26.228 340.946 26.42 341.138 26.588C341.342 26.744 341.57 26.87 341.822 26.966C342.086 27.05 342.362 27.092 342.65 27.092C343.214 27.092 343.646 26.996 343.946 26.804C344.246 26.6 344.462 26.36 344.594 26.084L346.538 27.164C346.43 27.392 346.28 27.632 346.088 27.884C345.896 28.124 345.644 28.346 345.332 28.55C345.032 28.754 344.66 28.922 344.216 29.054C343.784 29.186 343.274 29.252 342.686 29.252C342.014 29.252 341.402 29.144 340.85 28.928C340.298 28.712 339.818 28.4 339.41 27.992C339.014 27.584 338.702 27.086 338.474 26.498C338.258 25.91 338.15 25.244 338.15 24.5V24.392C338.15 23.708 338.264 23.084 338.492 22.52C338.732 21.956 339.056 21.476 339.464 21.08C339.872 20.684 340.346 20.378 340.886 20.162C341.438 19.934 342.026 19.82 342.65 19.82C343.418 19.82 344.078 19.958 344.63 20.234C345.182 20.498 345.638 20.84 345.998 21.26C346.358 21.668 346.622 22.124 346.79 22.628C346.958 23.12 347.042 23.6 347.042 24.068V25.274H340.49ZM342.632 21.872C342.056 21.872 341.588 22.022 341.228 22.322C340.868 22.61 340.634 22.946 340.526 23.33H344.738C344.666 22.91 344.438 22.562 344.054 22.286C343.682 22.01 343.208 21.872 342.632 21.872ZM349.081 20.072H352.861V21.368H353.185C353.353 20.876 353.635 20.498 354.031 20.234C354.439 19.958 354.925 19.82 355.489 19.82C356.377 19.82 357.091 20.102 357.631 20.666C358.171 21.218 358.441 22.064 358.441 23.204V23.6L356.101 23.816V23.564C356.101 23.072 355.975 22.682 355.723 22.394C355.471 22.094 355.093 21.944 354.589 21.944C354.085 21.944 353.689 22.118 353.401 22.466C353.113 22.814 352.969 23.312 352.969 23.96V26.84H355.021V29H348.865V26.84H350.701V22.232H349.081V20.072ZM366.582 20.072H368.85V31.196C368.85 31.604 368.718 31.94 368.454 32.204C368.202 32.468 367.872 32.6 367.464 32.6H362.154V30.44H366.096C366.42 30.44 366.582 30.26 366.582 29.9V27.704H366.258C365.862 28.736 365.01 29.252 363.702 29.252C363.258 29.252 362.844 29.18 362.46 29.036C362.076 28.892 361.74 28.67 361.452 28.37C361.164 28.07 360.936 27.698 360.768 27.254C360.612 26.798 360.534 26.264 360.534 25.652V20.072H362.802V25.184C362.802 25.82 362.952 26.318 363.252 26.678C363.552 27.026 364.002 27.2 364.602 27.2C365.286 27.2 365.784 26.984 366.096 26.552C366.42 26.108 366.582 25.508 366.582 24.752V20.072Z",
    fill: "#409BFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_173:31488)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 0H19V1.09524H17V2.19047H15V3.28571H13V4.38095H11V5.47619H10V6.57143H9V7.66667H8V8.76191H7V9.85714H6H5.5H5V10.9524H4.5H4V36.1429H4.5H5V37.2381H5.5H6H7V38.3333H8V39.4286H9V40.5238H10V41.619H11V42.7143H13V43.8095H15V44.9048H17V46L19 46H21H197H198H199L201 46V44.9048H203V43.8095H205V42.7143H207V41.619H208V40.5238H209V39.4286H210V38.3333H211V37.2381H212H212.5H213V36.1429H213.5H214V10.9524H213.5H213V9.85714H212.5H212H211V8.76191H210V7.66667H209V6.57143H208V5.47619H207V4.38095H205V3.28571H203V2.19047H201V1.09524H199V0H198H197H21Z",
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1075 23.248V28H76.7315V15.4H81.6635C82.3115 15.4 82.8755 15.508 83.3555 15.724C83.8355 15.928 84.2315 16.204 84.5435 16.552C84.8675 16.888 85.1075 17.278 85.2635 17.722C85.4315 18.154 85.5155 18.598 85.5155 19.054V19.486C85.5155 19.954 85.4315 20.416 85.2635 20.872C85.1075 21.316 84.8675 21.718 84.5435 22.078C84.2315 22.426 83.8355 22.708 83.3555 22.924C82.8755 23.14 82.3115 23.248 81.6635 23.248H79.1075ZM79.1075 20.98H81.4295C81.9575 20.98 82.3715 20.836 82.6715 20.548C82.9835 20.26 83.1395 19.888 83.1395 19.432V19.216C83.1395 18.76 82.9835 18.388 82.6715 18.1C82.3715 17.812 81.9575 17.668 81.4295 17.668H79.1075V20.98ZM88.023 25.84H91.047V21.232H88.239V19.072H93.315V25.84H95.907V28H88.023V25.84ZM93.873 16.426C93.873 16.666 93.825 16.894 93.729 17.11C93.645 17.314 93.525 17.494 93.369 17.65C93.213 17.794 93.027 17.914 92.811 18.01C92.607 18.094 92.391 18.136 92.163 18.136C91.923 18.136 91.701 18.094 91.497 18.01C91.293 17.914 91.113 17.794 90.957 17.65C90.801 17.494 90.675 17.314 90.579 17.11C90.495 16.894 90.453 16.666 90.453 16.426C90.453 16.186 90.495 15.964 90.579 15.76C90.675 15.544 90.801 15.364 90.957 15.22C91.113 15.064 91.293 14.944 91.497 14.86C91.701 14.764 91.923 14.716 92.163 14.716C92.391 14.716 92.607 14.764 92.811 14.86C93.027 14.944 93.213 15.064 93.369 15.22C93.525 15.364 93.645 15.544 93.729 15.76C93.825 15.964 93.873 16.186 93.873 16.426ZM107.595 24.724C107.391 25.78 106.905 26.632 106.137 27.28C105.381 27.928 104.367 28.252 103.095 28.252C102.435 28.252 101.817 28.15 101.241 27.946C100.677 27.742 100.185 27.448 99.7645 27.064C99.3445 26.68 99.0145 26.206 98.7745 25.642C98.5345 25.078 98.4145 24.436 98.4145 23.716V23.5C98.4145 22.78 98.5345 22.132 98.7745 21.556C99.0145 20.98 99.3445 20.488 99.7645 20.08C100.197 19.672 100.695 19.36 101.259 19.144C101.835 18.928 102.447 18.82 103.095 18.82C104.343 18.82 105.351 19.144 106.119 19.792C106.899 20.44 107.391 21.292 107.595 22.348L105.363 22.924C105.291 22.396 105.063 21.94 104.679 21.556C104.295 21.172 103.755 20.98 103.059 20.98C102.735 20.98 102.429 21.04 102.141 21.16C101.853 21.28 101.601 21.454 101.385 21.682C101.169 21.898 100.995 22.168 100.863 22.492C100.743 22.804 100.683 23.158 100.683 23.554V23.662C100.683 24.058 100.743 24.412 100.863 24.724C100.995 25.024 101.169 25.276 101.385 25.48C101.601 25.684 101.853 25.84 102.141 25.948C102.429 26.044 102.735 26.092 103.059 26.092C103.755 26.092 104.283 25.918 104.643 25.57C105.015 25.222 105.255 24.754 105.363 24.166L107.595 24.724ZM112.892 22.348H113.324L115.7 19.072H118.184V19.18L115.304 23.266V23.59L118.472 27.892V28H115.88L113.324 24.508H112.892V28H110.624V15.4H112.892V22.348ZM126.973 19.072H129.241V28H126.973V26.704H126.649C126.253 27.736 125.401 28.252 124.093 28.252C123.649 28.252 123.235 28.18 122.851 28.036C122.467 27.892 122.131 27.67 121.843 27.37C121.555 27.07 121.327 26.698 121.159 26.254C121.003 25.798 120.925 25.264 120.925 24.652V19.072H123.193V24.184C123.193 24.82 123.343 25.318 123.643 25.678C123.943 26.026 124.393 26.2 124.993 26.2C125.677 26.2 126.175 25.984 126.487 25.552C126.811 25.108 126.973 24.508 126.973 23.752V19.072ZM133.747 31.6H131.479V19.072H133.747V20.368H134.071C134.311 19.876 134.659 19.498 135.115 19.234C135.571 18.958 136.153 18.82 136.861 18.82C137.389 18.82 137.887 18.922 138.355 19.126C138.835 19.33 139.249 19.63 139.597 20.026C139.957 20.41 140.239 20.884 140.443 21.448C140.659 22.012 140.767 22.654 140.767 23.374V23.698C140.767 24.43 140.665 25.078 140.461 25.642C140.257 26.206 139.981 26.686 139.633 27.082C139.285 27.466 138.871 27.76 138.391 27.964C137.923 28.156 137.413 28.252 136.861 28.252C136.453 28.252 136.099 28.21 135.799 28.126C135.499 28.042 135.235 27.928 135.007 27.784C134.791 27.64 134.605 27.478 134.449 27.298C134.305 27.106 134.179 26.908 134.071 26.704H133.747V31.6ZM136.123 26.092C136.831 26.092 137.401 25.876 137.833 25.444C138.277 25 138.499 24.4 138.499 23.644V23.428C138.499 22.672 138.277 22.078 137.833 21.646C137.401 21.202 136.831 20.98 136.123 20.98C135.415 20.98 134.839 21.208 134.395 21.664C133.963 22.108 133.747 22.696 133.747 23.428V23.644C133.747 24.376 133.963 24.97 134.395 25.426C134.839 25.87 135.415 26.092 136.123 26.092Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.68,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.68,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.36,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.36,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.04,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.04,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.72,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.72,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.08,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.08,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.76,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.76,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.44,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.44,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.12,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.12,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.8,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.8,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.48,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.48,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.16,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.16,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.84,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.84,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.52,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.52,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.88,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.88,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.56,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.56,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.24,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.24,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.92,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.92,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.6,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.6,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.28,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.28,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.96,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.96,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.32,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.32,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.04,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.04,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.72,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.72,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.4,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.4,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.08,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.08,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.76,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.76,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.12,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.12,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.8,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.8,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.48,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.48,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.16,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.16,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.84,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.84,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.52,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.52,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.2,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.2,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.88,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.88,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.56,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.56,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.24,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.24,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.92,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.92,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.6,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.6,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.28,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.28,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.96,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.96,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.64,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.64,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.32,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.32,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.84,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.84,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.52,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.52,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.88,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.88,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.56,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.56,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.24,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.24,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.92,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.92,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.28,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.28,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.96,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.96,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.64,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.64,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.32,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.32,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.68,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.68,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.36,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.36,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.04,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.04,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.72,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.72,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.08,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.08,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.76,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.76,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.44,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.44,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.12,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.12,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.8,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.8,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.48,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.48,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.16,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.16,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.84,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.84,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.52,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.52,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.2,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.2,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.56,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.56,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.24,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.24,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.6,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.6,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.28,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.28,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.96,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.96,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.64,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.64,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.32,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.32,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.68,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.68,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.36,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.36,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.04,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.04,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.72,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.72,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.08,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.08,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.76,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.76,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.44,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.44,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.12,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.12,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.48,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.48,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.16,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.16,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.68,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.68,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.36,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.36,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.04,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.04,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.72,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.72,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.08,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.08,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.76,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.76,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.44,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.44,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.12,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.12,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.8,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.8,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.48,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.48,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.16,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61.16,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.84,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.84,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.52,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.52,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.2,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.88,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.88,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.56,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.56,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.24,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.24,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.92,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.92,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.6,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.6,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.28,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.28,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.96,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.96,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.64,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.32,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.32,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.68,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.36,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.04,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.04,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.72,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.72,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.4,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.4,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.08,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.08,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.76,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.76,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.44,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.12,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.12,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.8,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.8,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.48,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 149.48,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.16,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.16,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.84,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156.84,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.52,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.52,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.2,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.2,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.88,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.88,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.56,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.56,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.24,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.24,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.92,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.92,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.6,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.6,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.28,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.28,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.96,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189.96,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.64,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.64,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.32,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.32,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.84,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.84,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.52,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.52,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.2,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.88,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.88,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.56,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.56,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.24,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.24,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.92,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40.92,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.6,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.28,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48.28,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.96,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.96,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.64,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.64,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.32,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.32,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.68,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.68,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.36,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.36,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.04,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.04,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.72,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.72,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.4,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.08,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.08,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.76,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.76,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.44,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.44,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.12,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.12,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.8,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.8,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.48,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.48,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.16,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.16,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.84,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.84,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.52,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.52,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.2,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.2,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.88,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.56,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.56,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.24,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.24,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.92,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.6,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.6,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.28,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.28,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.96,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.96,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.64,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.64,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.32,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.32,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.68,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.68,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.36,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.36,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.04,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.04,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.72,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.72,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.4,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.08,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.08,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.76,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.76,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.44,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.44,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.12,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.12,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.8,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.48,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.48,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.16,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 199.16,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_173:31488",
    x: 3.5,
    y: 1.5,
    width: 429,
    height: 45.9796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_173:31488"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_173:31488",
    x: 0,
    y: 0,
    width: 218,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_173:31488"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_173:31488",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickupSelected);
export default __webpack_public_path__ + "static/media/PickupSelected.54d88927149f8071567e118922f86500.svg";
export { ForwardRef as ReactComponent };